export default __webpack_public_path__ + "static/assets/0abb1e782e4d4daaa63202330d0ea467.svg";